import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from 'clsx'

class FolioBuilderRouting extends React.Component {
  constructor(props) {
    super(props)

    this.onChange = this.onChange.bind(this);
    this.onChangeFolioItemType = this.onChangeFolioItemType.bind(this);
    this.onSelectAllNone = this.onSelectAllNone.bind(this);


  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'routing',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="routing">

        {/* {this.renderErrors()} */}

        {this.renderPrintButton()}

        <div className="row">
          <div className="col-md-12">
            {this.props.read_only ? this.renderFolioItemTypes() : this.renderFolioItemTypesForm()}
          </div>
        </div>

      </div>
    );
  }

  renderFolioItemTypes() {
    var self = this;
    var numChecked = 0;
    var folioItemTypes = this.props.folio_item_types.map(function (folioItemType) {
      if (self.isChecked(folioItemType.id)) {
        numChecked++;
        return <li key={folioItemType.id}>{folioItemType.name}</li>
      }
    });

    if (numChecked > 0 && folioItemTypes) {
      return (
        <ul style={{margin: 0}}>
          {folioItemTypes}
        </ul>
      );
    } else {
      return (
        <div>
          <span className="none">{I18n.t('none')}</span>
        </div>
      );
    }
  }

  renderFolioItemTypesForm() {
    var self = this;

    var folioItemTypes = this.props.folio_item_types.map(function (folioItemType) {
      return self.renderFolioItemType(folioItemType);
    });

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="select-all-none">
            <div className="toggle"><label><input type="checkbox" onChange={this.onSelectAllNone} checked={this.props.folio_item_type_ids ? (this.props.folio_item_types.length == this.props.folio_item_type_ids.length) : false} /> {I18n.t('select_all_none')}</label></div>
            <hr />
            <div className="items">
              <input type="hidden" name="product[folio_item_type_ids][]" />
              {folioItemTypes}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFolioItemType(folioItemType) {
    return (
      <div className="item" key={folioItemType.id}>
        <label><input type="checkbox" name="product[folio_item_type_ids][]" value={folioItemType.id} checked={this.isChecked(folioItemType.id)} onChange={this.onChangeFolioItemType.bind(null, folioItemType)} /> {folioItemType.name}</label>
      </div>
    )
  }

  renderErrors() {
    var errors = FolioBuilderErrors.folio_item_types(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderPrintButton() {
    if (this.props.print_button) {
      return (
        <div className="print-new-window" style={{position: 'absolute', top: -5, right: 0}}>
          <button className="btn btn-dark" title={I18n.t('print')}><span className="ss-print"></span></button>
        </div>
      );
    } else {
      return null;
    }
  }

  /**********
  * Helpers *
  ***********/

  isChecked(id) {
    for (var i = 0, ilen = this.props.folio_item_type_ids.length; i < ilen; i++) {
      if (this.props.folio_item_type_ids[i] == id) {
        return true;
      }
    }
    return false;
  }

  /*****************
  * Event Handlers *
  ******************/

  onChange(folio_item_type_ids) {
    this.props.onChange({
      target: {
        name: 'folio_item_type_ids',
        value: folio_item_type_ids
      }
    });
  }

  onChangeFolioItemType(folioItemType, event) {
    var folio_item_type_ids = this.props.folio_item_type_ids.slice(0);
    var folioItemTypeIds = this.props.folio_item_type_ids.slice(0);
    var matchIndex = -1;

    for (var i = 0, ilen = folioItemTypeIds.length; i < ilen; i++) {
      if (folioItemTypeIds[i] == folioItemType.id) {
        matchIndex = i;
        break;
      }
    }

    if (matchIndex !== -1 && !event.target.checked) {
      folio_item_type_ids.splice(matchIndex, 1);
    }
    if (matchIndex === -1 && event.target.checked) {
      folio_item_type_ids.push(folioItemType.id);
    }

    this.onChange(folio_item_type_ids);
  }

  onSelectAllNone(event) {
    if (event.target.checked) {
      var folio_item_type_ids = this.props.folio_item_types.map(function (folio_item_type) { return folio_item_type.id; });
    } else {
      var folio_item_type_ids = [];
    }

    this.onChange(folio_item_type_ids);
  }
}

export default FolioBuilderRouting